"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PATIENT_TO_HL7_MAPPING = void 0;
exports.PATIENT_TO_HL7_MAPPING = [
    { patientDtoField: 'uhid', hl7Field: 'PID-3', messageTypes: ['ADT^A04', 'ADT^A28'] },
    { patientDtoField: 'givenName', hl7Field: 'PID-5.2', messageTypes: ['ADT^A04', 'ADT^A28'] },
    { patientDtoField: 'familyName', hl7Field: 'PID-5.1', messageTypes: ['ADT^A04', 'ADT^A28'] },
    { patientDtoField: 'dateOfBirth', hl7Field: 'PID-7', messageTypes: ['ADT^A04', 'ADT^A28'] },
    {
        patientDtoField: 'genderId',
        hl7Field: 'PID-8',
        messageTypes: ['ADT^A04', 'ADT^A28'],
        notes: 'Requires the same LookupValue -> fixed-code-set mapping table fhir-mapping.types.ts names for FHIR gender.',
    },
    { patientDtoField: 'dateOfDeath', hl7Field: 'PID-29', messageTypes: ['ADT^A04'] },
];
//# sourceMappingURL=hl7-mapping.types.js.map